<script>
const sidebarMenu = [
  //   { path: '/dashboard', icon: 'fa fa-th', title: 'menu.dashboard',
  //     children: [
  //       { path: '/dashboard/v1', title: 'menu.dashboard1' },
  //       { path: '/dashboard/v2', title: 'menu.dashboard2' },
  //       { path: '/dashboard/v3', title: 'menu.dashboard3' }
  //     ]
  //   },
  {
    icon: "fas fa-th",
    title: "menu.corporate",
    children: [
      {
        path: "/admin/corporate/company-profiles",
        title: "menu.companyProfile",
      },
      {
        path: "/admin/corporate/branch-profiles",
        title: "menu.branchProfile",
      },
    ],
  },
  {
    icon: "fas fa-users",
    title: "menu.security",
    children: [
      { path: "/admin/roles", title: "menu.role" },
      { path: "/admin/users", title: "menu.user" },
    ],
  },
  {
    icon: "fas fa-business-time",
    title: "menu.humanResource",
    children: [
      // {
      //   path: "/admin/hr/shifts",
      //   title: "menu.shift",
      // },
      {
        path: "/admin/hr/status-reasons",
        title: "menu.statusReason",
      },
      // {
      //   path: "/admin/hr/payroll-cycle-dates",
      //   title: "menu.payrollCycleDate",
      // },
      {
        path: "/admin/hr/employee-profiles",
        title: "menu.employeeProfile",
      },
    ],
  },
  {
    icon: "fas fa-graduation-cap",
    title: "menu.Academic",
    children: [
      {
        title: "menu.setUp",
        children: [
          {
            path: "/admin/academic/candidate-profiles",
            title: "menu.candidateProfiles",
          },
          {
            path: "/admin/academic/trainer-profiles",
            title: "menu.trainerProfile",
          },
          {
            path: "/admin/academic/sector-profiles",
            title: "menu.sectorProfile",
          },
          {
            path: "/admin/academic/skill-profiles",
            title: "menu.skillProfile",
          },
          {
            path: "/admin/academic/level-skills",
            title: "menu.levelSkill",
          },
          {
            path: "/admin/academic/subject-profiles",
            title: "menu.subjectProfile",
          },
          {
            path: "/admin/academic/level-skill-subjects",
            title: "menu.levelSkillSubject",
          },
        ],
      },
      {
        title: "menu.operation",
        children: [
          {
            path: "/admin/academic/course-skills",
            title: "menu.courseSkill",
          },
          {
            path: "/admin/academic/exam-registers",
            title: "menu.examRegister",
          },
          {
            path: "/admin/academic/evaluation-examinations",
            title: "menu.evaluationExamination",
          },
          {
            path: "/admin/academic/candidate-certificates",
            title: "menu.candidateCertificate",
          },
          {
            path: "/admin/academic/accessor-certificate-requests",
            title: "menu.accessorCertificateRequest",
          },
          {
            path: "/admin/academic/certificate-operation-prints",
            title: "menu.certificateOperationPrint",
          },
        ],
      },
      {
        title: "menu.setting",
        children: [
          {
            path: "/admin/academic/certificates",
            title: "menu.certificate",
          },
        ],
      },
    ],
  },
  {
    icon: "fas fa-file-invoice",
    title: "menu.report",
    children: [
      {
        path: "/admin/report/candidate-profile-lists",
        title: "menu.candidateProfileList",
      },
      {
        path: "/admin/report/exam-registration-lists",
        title: "menu.examRegistrationList",
      },
      // {
      //   path: "/admin/report/exam-evaluation-details",
      //   title: "menu.examEvaluationDetail",
      // },
      {
        path: "/admin/report/exam-evaluation-lists",
        title: "menu.examEvaluationList",
      },
      {
        path: "/admin/report/print-operation-lists",
        title: "menu.printOperation",
      },
    ],
  },
];
export default sidebarMenu;
</script>
